import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MediaSlotView } from "../render/context";
import { resolveSlotMedia } from "../render/slot-media";
import { Section } from "./_section";
/**
 * PlaygroundCardBlock — test-only single-target card (frozen contract:
 * docs/briefs/playground-components.md §1). Serves place-image-in-block-slot
 * and show-image-for-screen's single-target control. Rendered identically by
 * the CMS canvas and the public site; only image resolution differs, via
 * BlockRenderProvider.
 */
const CONTAINER = "mx-auto max-w-7xl px-4 @min-[640px]:px-6 @min-[1024px]:px-8";
export function PlaygroundCardBlock({ data }) {
    const { heading, subheading, icon } = data;
    return (_jsx(Section, { children: _jsx("div", { className: CONTAINER, children: _jsxs("div", { className: "mx-auto flex max-w-3xl flex-col items-center gap-3 text-center", children: [icon && (_jsx("div", { className: "inline-flex size-24 items-center justify-center overflow-hidden rounded-xl", children: _jsx(MediaSlotView, { image: icon, ratio: "1 / 1", label: "Icon", className: "size-24", emptyRender: null }) })), _jsx("h3", { className: "text-2xl font-bold tracking-tight", children: heading }), subheading && (_jsx("p", { className: "max-w-prose text-base text-muted-foreground", children: subheading }))] }) }) }));
}
export function playgroundCardFromBlock(block, resolve) {
    const s = block.scalars ?? {};
    return {
        heading: s.heading || "",
        subheading: s.subheading || undefined,
        // One declared target (single-target by frozen contract), so this resolves
        // to a single framing every screen sees.
        icon: resolveSlotMedia(block, "icon", resolve),
    };
}
export const playgroundCardBlockEntry = {
    Component: PlaygroundCardBlock,
    fromBlock: playgroundCardFromBlock,
};
//# sourceMappingURL=playground-card.js.map